import React, { useState } from 'react';
import { toast } from 'sonner';
import Seo from '../components/Seo';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', order: '', message: '' });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill all required fields.');
      return;
    }
    toast.success('Ticket opened. We reply within one business day.');
    setForm({ name: '', email: '', order: '', message: '' });
  };

  return (
    <main className="max-w-[720px] mx-auto px-6 md:px-10 pt-16 pb-16">
      <Seo
        title="Contact Vial Rat Research Co. | Canadian Research Peptide Support"
        description="Get in touch with Vial Rat Research Co. for order support, product ETAs and research enquiries. Canadian based, replies by email."
        canonicalPath="/contact"
      />
      <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-4">OPEN A TICKET</div>
      <h1 className="font-serif-display text-white text-6xl md:text-7xl">Contact</h1>

      <form onSubmit={submit} className="mt-12 space-y-6">
        {[
          { key: 'name', label: 'NAME', type: 'text', required: true },
          { key: 'email', label: 'EMAIL', type: 'email', required: true },
          { key: 'order', label: 'ORDER NUMBER (OPTIONAL)', type: 'text', required: false },
        ].map(f => (
          <div key={f.key}>
            <label className="font-mono-label text-[10px] text-neutral-400 block mb-2">{f.label}</label>
            <input type={f.type} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
              className="w-full bg-transparent border-b border-white/15 focus:border-[#ff2fa1] outline-none py-3 text-white transition-colors" />
          </div>
        ))}
        <div>
          <label className="font-mono-label text-[10px] text-neutral-400 block mb-2">MESSAGE</label>
          <textarea rows={5} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })}
            className="w-full bg-transparent border-b border-white/15 focus:border-[#ff2fa1] outline-none py-3 text-white transition-colors resize-none" />
        </div>
        <button type="submit" className="btn-pink px-8 py-4 rounded font-mono-label text-[11px]">SUBMIT</button>
      </form>

      <div className="mt-16 p-6 border border-[#ff2fa1]/20 bg-[#ff2fa1]/5 rounded">
        <div className="font-mono-label text-[11px] text-[#ff2fa1]">FOR RESEARCH USE ONLY</div>
        <p className="text-sm text-neutral-400 mt-2">Products are intended for laboratory and research purposes only. Not for human or veterinary use, food, or household application.</p>
      </div>
    </main>
  );
};

export default Contact;
